import { getSkewCorrectedDate } from "./getSkewCorrectedDate";
export var isClockSkewed = function (clockTime, systemClockOffset) {
    return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - clockTime) >= 300000;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/middleware-signing/dist-es/utils/isClockSkewed.js
// module id = 710
// module chunks = 0